import * as Sentry from '@sentry/vue';

/**
 * Initialize Sentry error tracking with BetterStack
 * @param {import('vue').App} app - Vue application instance
 * @param {import('vue-router').Router} router - Vue router instance
 */
export function initSentry(app, router) {
  // Only initialize in production or if explicitly enabled
  const isEnabled = import.meta.env.PROD || import.meta.env.VITE_SENTRY_ENABLED === 'true';

  if (!isEnabled) {
    console.log('[Sentry] Disabled in development mode');
    return;
  }

  const dsn = import.meta.env.VITE_SENTRY_DSN;

  if (!dsn) {
    console.warn('[Sentry] No DSN configured, skipping initialization');
    return;
  }

  Sentry.init({
    app,
    dsn,
    environment: import.meta.env.MODE,
    integrations: [Sentry.browserTracingIntegration({ router })],
    // Performance monitoring sample rate
    tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0,
  });

  console.log('[Sentry] Initialized successfully');
}
